import {mapApi} from "@/api/designer-api";
import * as echarts from 'echarts'
import cityProvince from "@/assets/map/city-province.json";

export async function registerMap(provinceCode, cityCode){
    let code = cityCode ? cityCode:provinceCode;
    if(code !== 'china'){
        const rMap = echarts.getMap(code);
        if(rMap === null || rMap === undefined){//如果已经注册到echarts就不再拉取地图json文件
            await mapApi(code).then(res => {//从dataV获取城市地图的JSON文件
                echarts.registerMap(code, res.data);//注册地图
            })
        }
    }
    return code;
}

export function getCodeByName(name,parentCode){
    if(parentCode === 'china'){
        for (let i = 0; i < cityProvince.length; i++) {
            const province = cityProvince[i];
            if (province.name.indexOf(name) === 0){
                return province.code
            }
        }
    }else{
        for (let i = 0; i < cityProvince.length; i++) {
            const province = cityProvince[i];
            if (province.code === parentCode){
                for (let j = 0; j < province.cities.length; j++) {
                    const city = province.cities[j]
                    if (city.name.indexOf(name) === 0){
                        return city.code
                    }
                }
            }
        }
    }
    console.warn('城市：'+name+'，在父级：'+parentCode+'未找到')
    return null;
}

export function getChildByParentCode(parentCode){
    for (let i = 0; i < cityProvince.length; i++) {
        const item = cityProvince[i]
        if(item.code === parentCode){
            return item.cities
        }
    }
}

/**
 *  将{name:value}的list转为{name:[lng,lat,value]}
 * @param dataList  如[{name:广东,value:100}...]
 * @param features  echarts地图GeoJson---->vue.prototype.$echarts.getMap(cityCode).geoJSON.features
 * return 如[{name:广东,value:[127.212,36.3221,100]}...]
 */
export function transferGeoJSON(dataList, features){
    let res = []
    dataList.forEach(item => {
        const geo = features.find((feature) => {return item.name === feature.properties.name})
        if(geo){
            let center = geo.properties.cp || geo.properties.center
            const tranValue = center.concat(item.value)
            res.push({name:item.name,value:tranValue})
        }
    })
    return res
}
